import { useCallback, useRef, useState } from "react";

import Api from "./api";

export function useStatisticsDashboard({ filters, intl }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState(null);

  const stateRef = useRef({
    filters,
    intl,
  });

  stateRef.current = { filters, intl };

  // Função para buscar dados da API
  const fetchStatisticsDashboardData = useCallback(async (nextFilters) => {
    setLoading(true);
    setNotification(null);

    try {
      const { filters: currentFilters } = stateRef.current;
      const requestFilters = nextFilters || currentFilters || {};

      const response = await Api.get("/dashboard/statistics", {
        params: requestFilters,
      });

      if (response?.data?.success) {
        const responseData = response.data.data;
        setData(responseData);
        return responseData;
      } else {
        const { intl: intlRef } = stateRef.current;
        setNotification({
          variant: "error",
          message: response?.data?.errors?.[0] || intlRef?.formatMessage?.({ id: "process.error" }) || "Erro"
        });
        return null;
      }
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') {
        return;
      }

      const { intl: intlRef } = stateRef.current;
      setNotification({
        variant: "error",
        message: err.response?.data?.errors?.[0] || intlRef?.formatMessage?.({ id: "process.error" }) || "Erro"
      });
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearNotification = useCallback(() => {
    setNotification(null);
  }, []);

  // Retorna estado diretamente - componente pai só precisa usar esses valores
  return {
    data,
    loading,
    notification,
    fetchStatisticsDashboardData,
    clearNotification,
  };
}
